export default __webpack_public_path__ + "static/media/image-chairsensor-w.b873d80c.webp";